// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__37IM1","actionsCol":"EnrolledClinics_actionsCol__3r-cd"};